module.exports = __webpack_public_path__ + "static/media/order-not-found.96d7af73.svg";